import { AbstractControl } from "@angular/forms";

const hasUpperCaseValidator = (control: AbstractControl) => {
  const value: string = control.value || "";
  const hasUpperCase = /[A-Z]/.test(value);
  return hasUpperCase ? null : { noUpperCase: true };
};

const hasLowerCaseValidator = (control: AbstractControl) => {
  const value: string = control.value || "";
  const hasLowerCase = /[a-z]/.test(value);
  return hasLowerCase ? null : { noLowerCase: true };
};
const hasNumberValidator = (control: AbstractControl) => {
  const value: string = control.value || "";
  const hasNumber = /[0-9]/.test(value);
  return hasNumber ? null : { noNumber: true };
};
const lengthBetween6And64Validator = (control: AbstractControl) => {
  const value: string = control.value || "";
  const length = value.length;
  if (8 < length && length < 64) {
    return null;
  }
  return { lengthOutOfRange: true };
};

const passwordCriteriaTexts = Object.entries({
  noUpperCase: "At least one uppercase letter (A-Z)",
  noLowerCase: "At least one lowercase letter (a-z)",
  noNumber: "At least one number (0-9)",
  lengthOutOfRange: "Between 8 and 64 characters",
});

export {
  hasUpperCaseValidator,
  hasLowerCaseValidator,
  hasNumberValidator,
  lengthBetween6And64Validator,
  passwordCriteriaTexts,
};
